module.exports = __webpack_public_path__ + "img/full-screen-image-1.30b1c71b.jpg";